// extracted by mini-css-extract-plugin
export default {"root":"Cta_root__0MhS0","mainTitle":"Cta_mainTitle__3E5Ev","CtaContent":"Cta_CtaContent__8teDN","inner":"Cta_inner__FiuuT","item":"Cta_item__E5TXU","button":"Cta_button__1SaJo"};